"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PxtTelemetryAssetIntegratedWebClient = void 0;
const DataPxtTelemetryEvents_1 = require("./DataPxtTelemetryEvents");
const reactPortalTelemetryCompatibilityPatchImplementation_1 = require("./patches/reactPortalTelemetryCompatibilityPatchImplementation");
const DataPxtTelemetryContext_1 = require("./DataPxtTelemetryContext");
class PxtTelemetryAssetIntegratedWebClient {
    constructor(namespace, sendImperative, sendImperativeExplicitPath, collectPathsWindow, describeActorImplementation, __unstable_sendImperativeImplementation, __unstable_domContextProviderImplementation, __unstable_experimentationProviderImplementation) {
        this.namespace = namespace;
        this.sendImperative = sendImperative;
        this.sendImperativeExplicitPath = sendImperativeExplicitPath;
        this.collectPathsWindow = collectPathsWindow;
        this.describeActorImplementation = describeActorImplementation;
        this.__unstable_sendImperativeImplementation = __unstable_sendImperativeImplementation;
        this.__unstable_domContextProviderImplementation = __unstable_domContextProviderImplementation;
        this.__unstable_experimentationProviderImplementation = __unstable_experimentationProviderImplementation;
        this.__unstable_sendImperativeEvent = (event, options) => {
            try {
                this.__unstable_sendImperativeImplementation()(event, this.namespace, options);
            }
            catch (e) {
                // TODO - capture error log
            }
        };
    }
    describeEvents(...args) {
        const eventsWithTriggerResourceNames = typeof args[0] === "string"
            ? [
                {
                    triggerResourceNames: [args[0]],
                    events: args.slice(1),
                },
            ]
            : args;
        return new DataPxtTelemetryEvents_1.DataPxtTelemetryEvents(eventsWithTriggerResourceNames);
    }
    __unstable_describeContext(...context) {
        return new DataPxtTelemetryContext_1.ContextData(context).getDataPair();
    }
    sendImperativeEventsExplicitPath(...events) {
        try {
            this.sendImperativeExplicitPath()(...events);
        }
        catch (e) {
            // TODO - capture error log
        }
    }
    sendImperativeEvents(...events) {
        try {
            this.sendImperative()(...events.map(({ event, metaPayload }) => ({
                event,
                metaPayload: {
                    namespacePath: [this.namespace],
                    ...metaPayload,
                },
            }), this));
        }
        catch (e) {
            // TODO - capture error log
        }
    }
    get __unstable_domContextProvider() {
        try {
            return this.__unstable_domContextProviderImplementation();
        }
        catch (e) {
            // TODO - capture error log
            // Return a dummy context provider
            return {
                get: () => [],
            };
        }
    }
    async getLitmusTreatmentAndRecordTrigger(experimentId) {
        try {
            const sdk = this.__unstable_experimentationProviderImplementation();
            return await sdk.getTreatmentAssignmentAndRecordTrigger(experimentId, this.namespace);
        }
        catch (e) {
            // TODO - capture error log
            // Return a dummy experiment SDK
            return null;
        }
    }
    sendCriticalFeatureDuration(scopePath, durationMilliseconds) {
        try {
            this.sendImperativeEvents({
                event: {
                    resourceName: "arn:pxt:telemetry:event:core:timetocriticalfeature:1.0.0",
                    payload: {
                        durationMilliseconds,
                    },
                },
                metaPayload: {
                    scopePath: scopePath,
                },
            });
        }
        catch (e) {
            // TODO - capture error log
        }
    }
    reactPortalTelemetryCompatibilityPatch(element) {
        let collectPaths;
        try {
            collectPaths = this.collectPathsWindow();
        }
        catch (e) {
            collectPaths = undefined;
        }
        return (0, reactPortalTelemetryCompatibilityPatchImplementation_1.reactPortalTelemetryCompatibilityPatchImplementation)(collectPaths, element);
    }
    describeActor(actor) {
        try {
            this.describeActorImplementation()(actor);
        }
        catch (e) {
            // TODO - capture error log
        }
    }
    collectPaths(element) {
        try {
            return this.collectPathsWindow()(element);
        }
        catch (e) {
            // TODO - capture error log
            return undefined;
        }
    }
}
exports.PxtTelemetryAssetIntegratedWebClient = PxtTelemetryAssetIntegratedWebClient;
